import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-medcare-core-ui',
  template: `
    <p>
      medcare-core-ui works!
    </p>
  `,
  styles: [
  ]
})
export class MedcareCoreUiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
